<template>
  <div class="choices-wrap">
    <div
      class="choices"
      :class="choicesClasses"
    >
      <button
        v-for="(choice, index) in choices"
        :key="index"
        class="button"
        @click="$emit('buttonClick', choice)"
      ></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Choices',
  props: {
    choices: {
      type: Array,
      default () {
        return []
      }
    },
    mode: {
      type: String,
      required: false
    }
  },
  computed: {
    choicesClasses () {
      return {
        'triwave': this.mode === 'triwave',
        'two-buttons': this.choices.length === 2,
        'three-buttons': this.choices.length === 3
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.choices-wrap {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  max-width: 1300px;
  height: 0;
  padding-bottom: 56.25%;
  z-index: 10;
  margin: 0 auto;
}

.choices {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  z-index: 10;
  align-items: stretch;
  justify-content: space-around;
  flex: 1;
  margin: 0 auto;
  pointer-events: auto;
}

.two-buttons .button {
  width: 50%;
}

.three-buttons .button {
  width: 33%;
}

.triwave {
  flex-wrap: wrap;

  .button {
    width: 50%;
  }

  .button:first-child {
    width: 100%;
  }
}

.button {
  -webkit-appearance: none;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  box-shadow: none;
  outline: 0;
}
</style>
